import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';
import { DEFAULT_PAGE_SIZE } from '@src/utils/constants';

export const serviceApi = createApi({
  reducerPath: 'Service',
  tagTypes: ['Service'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getService: builder.mutation({
      query: ({ argument: { pathName }, body = {}, params = {} }) => ({
        url: `/v1/company/service/${pathName}`,
        method: 'POST',
        body,
        params: {
          sortBy: 'expirationDate',
          sortDir: 'desc',
          page: 0,
          size: DEFAULT_PAGE_SIZE,
          ...params,
        },
      }),
    }),

    getServiceById: builder.query({
      query: ({ id }) => ({
        url: `/v1/company/service/${id}`,
      }),
    }),
    createOrUpdateService: builder.mutation({
      query: ({ data, pathname, method }) => ({
        url: `${pathname}`,
        method: method,
        body: data,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetServiceMutation,
  useCreateOrUpdateServiceMutation,
  useLazyGetServiceByIdQuery,
} = serviceApi;
